<ion-content class="ion-padding"  scrollY="false">
  <div class="em-manutencao__content">
    <img class="em-manutencao__img" src="assets/images/em_manutencao.svg" alt="Sistema em manutenção" />

    <ion-text class="ion-text-center">
      <h1>Sistema em manutenção</h1>
      <p>O aplicativo voltará a funcionar normalmente em algumas horas.</p>
    </ion-text>

    <ion-text class="ion-text-center">
      <p>
        Para assuntos urgentes, entre em contato por Whatsapp:
      </p>

      <a class="em-manutencao__whatsapp" [href]="whatsUrl" target="blank" rel="noopener noreferrer">
        <ion-icon name="logo-whatsapp"></ion-icon>
        Preciso de ajuda
      </a>
    </ion-text>

    <usucampeao-footer></usucampeao-footer>
  </div>
</ion-content>